var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpwork1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 33,
    viewBox: "0 0 40 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_16)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_16",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V33H40V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0157 20.8412C29.1739 20.8412 27.4482 20.0813 25.8803 18.8444L26.262 17.0982L26.2786 17.0335C26.6186 15.1742 27.6971 12.0535 31.0157 12.0535C33.5043 12.0535 35.5286 14.0262 35.5286 16.4513C35.5202 18.8685 33.4961 20.8412 31.0157 20.8412ZM31.0157 7.59912C26.7762 7.59912 23.4911 10.2831 22.1557 14.6972C20.1148 11.714 18.5716 8.13277 17.6674 5.11725H13.1047V16.6858C13.1047 18.9656 11.1965 20.8248 8.85707 20.8248C6.51756 20.8248 4.60967 18.9656 4.60967 16.6858V5.11725H0.0464388V16.6858C0.0298388 21.4233 3.98706 25.3118 8.8484 25.3118C13.71 25.3118 17.6672 21.4233 17.6672 16.6858V14.7457C18.5548 16.5484 19.6415 18.3673 20.9607 19.9843L18.1648 32.7896H22.8356L24.8597 23.5009C26.635 24.6084 28.6759 25.3038 31.0154 25.3038C36.0177 25.3038 40.0911 21.3101 40.0911 16.4352C40.0911 11.5684 36.018 7.59912 31.0157 7.59912Z",
    fill: "#AED6DC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 33,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpwork1);
export default __webpack_public_path__ + "static/media/upwork 1.f7483b02f3390a3a494c44e6fd8090a5.svg";
export { ForwardRef as ReactComponent };